import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';

import { Grid, GridItem, List } from './index.styles';
import EligibilityCriteria from 'images/overview/eligibility-criteria.png';
import WePromise from 'images/overview/we-promise.png';
import YouPromise from 'images/overview/you-promise.png';
import BulletIcon from 'images/overview/bullet.svg';
import { updateOverviewStep } from 'store/overview';
import { isMobile } from 'utils/isMobile';
import { PKDFilledButton } from 'components/FilledButton';

export const Overview = ({ onForward }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateOverviewStep('Overflow'));
  }, [dispatch]);

  return (
    <>
      <Grid>
        <GridItem>
          <img
            src={EligibilityCriteria} alt='eligibility-criteria'
          />
          <Typography
            variant='h6'
            color='primary.blue1'
            fontFamily='Montserrat'
            fontWeight='700'>
            Eligibility criteria
          </Typography>
          <List>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              You must be at least 18 years old
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              You can report for yourself or your child/dependent
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Have a confirmed or suspected diagnosis of ADPKD
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Reside in the United States
            </li>
          </List>
        </GridItem>
        <GridItem>
          <img
            src={WePromise} alt='eligibility-criteria'
          />
          <Typography
            variant='h6'
            color='primary.blue1'
            fontFamily='Montserrat'
            fontWeight='700'>
            We promise to
          </Typography>
          <List>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Keep your information private and secure
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Respect your time - take your interests to heart
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Keep you up-to-date - Make things easy
            </li>
          </List>
        </GridItem>
        <GridItem>
          <img
            src={YouPromise} alt='eligibility-criteria'
          />
          <Typography
            variant='h6'
            color='primary.blue1'
            fontFamily='Montserrat'
            fontWeight='700'>
            You promise to
          </Typography>
          <List>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Check in as often as you can
            </li>
            <li>
              <img
                src={BulletIcon} alt='bullet-icon'
              />
              Tell us about your disease journey
            </li>
          </List>
        </GridItem>
      </Grid>
      <Box
        mt={2} mb={2} display='flex' justifyContent='center'>
        <PKDFilledButton
          onClick={onForward}
          sx={{
            width      : isMobile() ? '100%' : '224px',
            marginLeft : '26px',
          }}>
          Continue
        </PKDFilledButton>
      </Box>
      {/* <ContinueBtn onClick={onForward}>Continue</ContinueBtn> */}
    </>
  );
};
